import { getLocalStorage } from './storage.js';

export default {
	applicationId: '633292a3-9da7-47e2-ac63-6f211a269d98',
	clientToken: 'pubf545178c85b44d2e28f26bfdfd051768',
	site: 'datadoghq.com',
	service: 'web-reg',
	version: import.meta.env.VITE_APP_VERSION,
	env: window.Stash.env,
	sessionSampleRate: 100,
	sessionReplaySampleRate: 20,
	trackUserInteractions: true,
	trackResources: true,
	trackLongTasks: true,
	defaultPrivacyLevel: 'mask-user-input',
	enableExperimentalFeatures: ['feature_flags'],
	compressIntakeRequests: true,
	allowedTracingUrls: getLocalStorage('allowTracingForPublicDomain')
		? [/https:\/\/.*\.stsh\.io/, /https:\/\/.*\.stash\.com/]
		: [/https:\/\/.*\.stsh\.io/],
	beforeSend: (event) => {
		// Don't log these errors - check both error messages and general message field
		if (
			event.message?.includes('Warning') ||
			event.message?.includes('Object Not Found Matching Id') ||
			event.error?.message?.includes('Warning') ||
			event.error?.message?.includes('Object Not Found Matching Id')
		) {
			return false;
		}
		return true;
	},
};
